/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Users_Select_UserInputs */

const cs_users_select_user = /** @type {(inputs: Users_Select_UserInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vybrat ${i?.name}`)
};

const en_users_select_user = /** @type {(inputs: Users_Select_UserInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Select {name}" |
*
* @param {Users_Select_UserInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const users_select_user = /** @type {((inputs: Users_Select_UserInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Select_UserInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_select_user(inputs)
	return cs_users_select_user(inputs)
});